import { Moment } from 'moment';

export enum DocumentsFormDataType {
  Period = 'Period'
}

export type DocumentsFormData = {
  [DocumentsFormDataType.Period]: Array<Moment>;
};
